import { Card, CardHeader } from 'reactstrap';
import { T } from '../../helpers/i18n';
import { Button, TextArea } from '../../elements';
import React from 'react';
export var BlockAdditionalNote = function (_a) {
    var value = _a.value, onChange = _a.onChange, onClick = _a.onClick;
    return (React.createElement(Card, { style: {
            borderColor: 'black',
            width: '100%',
            margin: 0,
            padding: 0
        } },
        React.createElement(CardHeader, null, T('additionalNote')),
        React.createElement(TextArea, { style: {
                paddingLeft: '10px',
                paddingRight: '10px'
            }, type: 'text', value: value, onChange: onChange }),
        React.createElement(Button, { onClick: onClick }, T('save'))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/BlockAdditionalNote.tsx
// module id = 1181
// module chunks = 0